import { render, staticRenderFns } from "./ProductMarketing.vue?vue&type=template&id=490dad46&scoped=true&"
import script from "./ProductMarketing.vue?vue&type=script&lang=js&"
export * from "./ProductMarketing.vue?vue&type=script&lang=js&"
import style0 from "./ProductMarketing.vue?vue&type=style&index=0&id=490dad46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490dad46",
  null
  
)

export default component.exports